// stockmatch.ts — which tracked inventory item a purchase-order line is
// (docs/SERVICE_SWITCHER_PLAN.md §13 item 26; the §13 item 18 follow-up).
//
// Receiving used to find the item by the line's label alone (engine_label,
// then name), so a foam set the owner named "Foam set 100 lb" in Inventory
// never took the delivery of a PO line called "Polyurethane lifting foam,
// 2-part set" — same SKU, different words. The SKU is the supplier's own
// number and travels from the recipe component to the PO line, so it goes
// first. Pure; the cloud bridge (supabase.ts VFP_STOCK.receiveLine) and the
// PO modal call it with the items they already hold.

export type StockKey = { sku?: string | null; label?: string | null };
export type StockMatch = { item: any; by: "sku" | "label" | "name" } | null;

const skuKey = (s: any) => String(s == null ? "" : s).trim().toLowerCase().replace(/[\s-]+/g, "");
const nameKey = (s: any) => String(s == null ? "" : s).trim().toLowerCase().replace(/\s+/g, " ");

/** the active item for a PO line: by SKU first (case and dashes don't matter), then the engine label, then the item's name */
export function stockMatch(items: any[] | null | undefined, q: StockKey): StockMatch {
  const list = (Array.isArray(items) ? items : []).filter((it) => it && it.active !== false);
  const sku = skuKey(q && q.sku);
  if (sku) {
    const hit = list.find((it) => skuKey(it.sku) === sku);
    if (hit) return { item: hit, by: "sku" };
  }
  const label = nameKey(q && q.label);
  if (!label) return null;
  const byLabel = list.find((it) => nameKey(it.engine_label) === label);
  if (byLabel) return { item: byLabel, by: "label" };
  const byName = list.find((it) => nameKey(it.name) === label);
  return byName ? { item: byName, by: "name" } : null;
}

/** each PO line → its item (or null), so the receiving panel can say where a delivery lands before it's checked in */
export function matchLines(items: any[] | null | undefined, lines: any[] | null | undefined): Record<string, StockMatch> {
  const out: Record<string, StockMatch> = {};
  (Array.isArray(lines) ? lines : []).forEach((l) => { if (l && l.label) out[l.label] = stockMatch(items, { sku: l.sku, label: l.label }); });
  return out;
}
